/* eslint-disable no-console */
/* eslint-disable arrow-body-style */
/* eslint-disable react/no-danger */
import React from 'react'
import cheerio from 'cheerio'
import styles from './mainContent.module.scss'

// Function to modify HTML content with Cheerio
const getModifiedHtml = htmlContent => {
  // Load the HTML content with Cheerio
  const $ = cheerio.load(htmlContent)

  // Modify <img> attributes
  $('img').attr('loading', 'lazy')
  $('img').attr('decoding', 'async')
  $('img').each((_, img) => {
    $(img).attr('width', '740')
    $(img).attr('height', '400')
  })

  // Return the modified HTML
  return $.html()
}

// Function to process data and return HTML string
const processDataToHtml = data => {
  if (Array.isArray(data)) {
    // If data is an array, concatenate the Content properties
    return data.map(item => item.Content).join('')
  } else if (typeof data === 'string') {
    // If data is a string, return it as is
    return data
  }
  // Handle any other formats if necessary
  return ''
}

// React component to render modified content
const ContentWithoutRef = ({ data }) => {
  const htmlContent = processDataToHtml(data)
  return (
    <div
      id="contentBeforeTocComponent"
      className={styles.heroImageBeforeToc}
      dangerouslySetInnerHTML={{ __html: getModifiedHtml(htmlContent) }}
    />
  )
}

export default ContentWithoutRef
